if (!customElements.get('collection-directory-search')) {
  class CollectionDirectorySearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-directory-search]');
      this.list = this.querySelector('[data-directory-list]');
      this.noResults = this.querySelector('[data-directory-no-results]');
      this.items = Array.from(this.querySelectorAll('[data-directory-item]'));
      if (!this.list) return;

      this.onInput = this.onInput.bind(this);
      this.onResize = this.onResize.bind(this);

      if (this.dataset.sort === 'alphabetical') {
        this.sortItemsAlphabetically();
      }

      this.input?.addEventListener('input', this.onInput);
      window.addEventListener('resize', this.onResize);
      this.layoutVisibleItems();
    }

    sortItemsAlphabetically() {
      this.items.sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || ''));
      this.items.forEach((item) => this.list.appendChild(item));
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      window.removeEventListener('resize', this.onResize);
    }

    getLayout() {
      const width = window.innerWidth;
      if (width >= 990) return { cycle: 7, firstRow: 4 };
      if (width >= 750) return { cycle: 5, firstRow: 3 };
      return { cycle: 3, firstRow: 2 };
    }

    layoutVisibleItems() {
      const { cycle, firstRow } = this.getLayout();
      let visibleIndex = 0;

      this.items.forEach((item) => {
        if (item.hidden) {
          item.removeAttribute('data-hex-pos');
          item.removeAttribute('data-hex-first-row');
          return;
        }

        item.dataset.hexPos = String(visibleIndex % cycle);
        item.dataset.hexFirstRow = visibleIndex < firstRow ? 'true' : 'false';
        visibleIndex += 1;
      });
    }

    onInput() {
      const query = (this.input?.value || '').trim().toLowerCase();
      let visibleCount = 0;

      this.items.forEach((item) => {
        const title = item.dataset.title || '';
        const match = query === '' || title.includes(query);
        item.hidden = !match;
        if (match) visibleCount += 1;
      });

      if (this.noResults) {
        this.noResults.hidden = visibleCount > 0;
      }

      this.layoutVisibleItems();
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => this.layoutVisibleItems(), 100);
    }
  }

  customElements.define('collection-directory-search', CollectionDirectorySearch);
}
